exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".duration{position:absolute;top:-10px;overflow:hidden;padding:0 2px;background:#fff;font-size:15px;color:rgba(0,0,0,.54)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09c577dd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/administration/leave_entry/leave_form.vue
// module id = 1295
// module chunks = 3